<template>
  <span class="text-grey-darker flex items-center justify-start text-base text-left whitespace-pre h-6">{{name}}</span>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default () {
        return ''
      },
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/TableComponents/Name.vue